// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PercentageChangeComponent } from './percentage-change/percentage-change.component';
import { AbsoluteValueModule } from '../absolute-value/absolute-value.module';


@NgModule({
  declarations: [PercentageChangeComponent],
  exports: [
    PercentageChangeComponent,
  ],
  imports: [
    CommonModule,
    AbsoluteValueModule,
  ],
})
export class PercentageChangeModule {
}
